module.exports = "varying vec2 vUv;\nvarying float noise;\nuniform sampler2D image;\n\n\nvoid main() {\n\n  vec2 uv = vec2(1,1) - vUv;\n  vec4 color = texture2D( image, uv );\n\n  gl_FragColor = vec4( color.rgb, 1.0 );\n\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/wood-frag.glsl
// module id = 11
// module chunks = 0